import React from 'react';

interface TabButtonProps {
  dataTourId?: string;
  label: string;
  isActive: boolean;
  onClick: () => void;
}

export const TabButton: React.FC<TabButtonProps> = ({
  dataTourId,
  label,
  isActive,
  onClick,
}) => (
  <button
    type="button"
    onClick={onClick}
    data-onboarding-tour={dataTourId}
    className={`
      whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm transition-colors
      ${
        isActive
          ? 'border-pos-primary text-pos-primary'
          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
      }
    `}
  >
    {label}
  </button>
);
